<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="oss-config-dialog"
  >
    <div class="form-content">
      <oss-config-form
        :form-data="formData"
        :key="formData.id"
        ref="outform"
        @submit="submit"
      ></oss-config-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import ossConfigForm from "@/components/sys/ossConfig/ossConfigForm";
import {addOrUpdateOssConfig} from "../../../api/sys/ossConfig/ossConfig";

export default {
  name: "editDialog",
  components: {
    ossConfigForm,
  },
  props: {
    formData:{
      type: Object,
    },
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '编辑云储存配置',
    }
  },
  watch:{
    dialogShow(newValue){
      if(newValue){
        setTimeout(() => {
          this.$refs.outform && this.$refs.outform.assigen(this.formData);
        },200);
      }
    },
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(params) {

      addOrUpdateOssConfig(params).then((data) => {
        if(data && data.code===200){
          this.$message({
            message: '编辑成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message({
            message: data.msg,
            type: 'error'
          });
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .oss-config-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
